import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';

import * as React from 'react';
import { useContext } from 'react';
import { ExchangeSubAccountStackRoutes, ExchangeSubAccountStackScreenProps } from '../../exchange.navigator';
import { ConfirmExchangeModal } from './ConfirmExchange.modal.web';

import { ConfirmExchangeStackParamList, ConfirmExchangeStackRoutes } from './type';

const ExchangeConfirmStack = createNativeStackNavigator<ConfirmExchangeStackParamList>();

export const ConfirmExchangeNavigator: React.FC<ExchangeSubAccountStackScreenProps<ExchangeSubAccountStackRoutes.ConfirmExchange>> = ({
  route
}) => {
  const { data, shouldBeFetchFee, onResult } = route.params;
  const layout = useContext(LayoutContext);
  return (
    <ExchangeConfirmStack.Navigator
      initialRouteName={ConfirmExchangeStackRoutes.ApplicationInstruction}
      screenOptions={{
        presentation: 'transparentModal',
        headerShown: false
      }}>
      <ExchangeConfirmStack.Screen
        name={ConfirmExchangeStackRoutes.ApplicationInstruction}
        component={ConfirmExchangeModal}
        initialParams={{ data, shouldBeFetchFee, onResult }}
      />
    </ExchangeConfirmStack.Navigator>
  );
};
